import { useEffect } from 'react';
import { Separator } from '../../../../../../../../../EHR/utils/utils';
// import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';

const Table = ({ item, setItem, activeAccordion, isGroupNote, ...props }) => {
    const headers = item.headers ? item.headers.split(Separator) : [];
    const rows = item.rows ?
        item.rows?.split("\n") ? item.rows?.split("\n") : item.rows?.split("\n") :
        [];

    // console.log("rowsTable",rows)
    const anyValExist = rows.some(row => row.split(Separator)?.some(cell => cell.trim() !== ''))
    // console.log("rowsTable",anyValExist)
    return (
        <div className="d-flex gap-10">
            <div className="ar-form-counter flex-center">
                <p className='text text-black'>{props?.itemCount}</p>
            </div>
            <div className='table-view template-acordian d-flex flex-column gap-6 min-w-0'>
                <label htmlFor="" className="heading fs-13">
                    {/* {item.content} */}
                    {item.IsRepeated === 'true' && item.IsGroupEncounter === 'true' && isGroupNote ? item.PatientName + ' - ' + item.content : item.content}
                </label>
                {console.log("Rows", rows)}
                {anyValExist ?
                    <div className="overflow-auto">
                        <table className='templates-table output' >
                            <thead>
                                <tr>
                                    {headers.length > 0 &&
                                        (headers.map((header, index) => (
                                            <th key={index} className='font-m fw-500 text w-auto'>{header}</th>
                                        )))}
                                </tr>
                            </thead>
                            <tbody>
                                {Array.from({ length: item.noOfRows || 2 }).map((_, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {rows?.[rowIndex]?.length > 0 &&
                                            (rows?.[rowIndex]?.split(Separator).length > 0 &&
                                                (rows?.[rowIndex]?.split(Separator).map((rowItem, cellIndex) => (
                                                    <td key={cellIndex} className='text w-auto text-nowrap'>
                                                        {rowItem}
                                                    </td>)

                                                )))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    :
                    <p className="text text-black fs-14">N/A</p>}
            </div >
        </div >
    );
};

export default Table